<template>
  <div>
    <b-modal
      id="modal-1"
      ok-only
      title="نتیجه به روز رسانی درگاه"
      ok-title="بازگشت"
      cancel-title="بستن"
      @ok="reloadPage"
    >
      <span v-html="response_text"></span>
    </b-modal>
    <list-table
      ref="TableShowData"
      :url="url"
      title=" لیست درگاههای تغییر یافته"
      :detailCallFun="detailCallFun"
      :detailCallFunType="detailCallFunType"
      @handle_function_call="onSubmit"
      :fields="fields"
      :params="params"
    ></list-table>
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import TableShowData from "../../components/table";
export default {
  name: "MerchantsUpdate",
  data() {
    return {
      response_text: "",
      url: "paymentgateways?update_required=1",
      detailCallFun: "onSubmit",
      detailCallFunType: "id",
      fields: [
        {
          key: "id",
          label: "کد",
        },
        {
          key: "user.name",
          label: "نام مالک درگاه",
          formatter(value, key, item) {
            return item.user.fa_name + " " + item.user.fa_family;
          },
        },
        {
          key: "acceptor_code",
          label: "کد پذیرنده",
        },
        {
          key: "website_name",
          label: "نام وبسایت",
        },
        {
          key: "website_en_name",
          label: "نام انگلیسی",
        },
        {
          key: "website",
          label: "آدرس",
        },
        {
          key: "statusName",
          label: "وضعیت",
          formatter: (value, key, item) => {
            return value;
          },
          tdClass: (value, key, item) => {
            return item.mdid19_status != 1580 ? "text-success" : "text-danger";
          },
        },
        {
          key: "request_status.title",
          label: "وضعیت درخواست",
        },
        {
          key: "money_type.title",
          label: "واحد پولی",
        },
        {
          key: "user.confirmallstatus",
          label: "وضعیت احراز هویت",
          formatter: (value, key, item) => {
            return value == true ? "احراز شده" : "احراز نشده";
          },
        },
        {
          key: "details",
          label: "جزییات",
        },
      ],
      params: [
        {
          label: "نام وبسایت",
          field: "website_name",
          type: "text",
        },
        {
          label: "نام انگلیسی وبسایت",
          field: "website_en_name",
          type: "text",
        },
        {
          label: "آدرس وبسایت",
          field: "website",
          type: "text",
        },
        {
          label: "کد پذیرنده",
          field: "acceptor_code",
          type: "text",
        },
        {
          label: "نام مالک درگاه",
          field: "name",
          type: "text",
        },
        {
          label: "وضعیت",
          field: "mdid19_status",
          type: "mddropdown",
          group: 19,
        },
        {
          label: "وضعیت درخواست",
          field: "mdid20_request_status",
          type: "mddropdown",
          group: 20,
        },
      ],
    };
  },
  components: {
    "list-table": TableShowData,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "لیست درگاه ها",
      },
    ]);
  },
  methods: {
    onSubmit(item) {
      this.response_text = "";
      httpHelper.setAuth();
      httpHelper.getData("updatemerchant/" + item.id).then((res) => {
        if (res.success && res.result !== null) {
          this.response_text = "درخواست با موفقیت ارسال گردید";
        } else {
          if (res.errors) {
            for (var key in res.errors) {
              this.response_text = res.errors[key] + "<br>";
            }
          }
        }

        if (this.response_text != "") {
          this.$bvModal.show("modal-1");
        }
      });
    },
    reloadPage() {
      this.$refs.TableShowData.LoadData(1);
    },
  },
};
</script>
